<template>
  <v-container>
    <v-layout text-center wrap>
      <v-flex xs12>
        <football-table
          :headers="headers"
          type="football"
          day="tomorrow"
          data-key="xht"
        />
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import FootballTable from '@/components/FootballTable';

export default {
  components: {
    FootballTable
  },
  data: () => ({
    headers: [
      { text: "Godzina", value: "date.time" },
      { text: "Liga", value: "league" },
      { text: "Dużyny", value: "teams.both" },
      { text: "Link", value: "url", sortable: false },
      { text: "X HT", value: "average", sortable: false }
    ]
  })
};
</script>
